import React from 'react'
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

export default class Shop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.update = this.update.bind(this);
    }

    update(e) {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        })
    }

    render() {
        let total = 0;
        Object.keys(this.props.info.products).forEach(product => {
            let qty = parseInt(this.state[product]) || 0;
            let price = parseInt(this.props.info.products[product]['price']) || 0
            total += (qty * price)
        })
        total += (parseInt(this.state.otherAmount) || 0);
        return (
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{minHeight: '100vh'}}
            >
                <Paper elevation={10} className="background-paper">
                    <div style={{textAlign: 'center'}}>
                        <img src='https://assets.tangentindia.org/assets/national_logo.png' style={{width: '50%'}} alt='Tangent India Logo'/>
                    </div>
                    <table>
                        <tbody>
                        <tr>
                            <th>
                                Product
                            </th>
                            <th>
                                Qty
                            </th>
                            <th>
                                Price
                            </th>
                        </tr>
                        {Object.keys(this.props.info.products).filter(product => this.props.info.products[product]['price']).map(product => {
                            return <tr>
                                <td>
                                    {this.props.info.products[product]['label']}
                                </td>
                                <td>
                                    <TextField id={"qty-" + product} label='Quantity' variant="outlined" type='number'
                                               value={this.state[product]} name={product} onChange={this.update} fullWidth/>
                                </td>
                                <td style={{textAlign: 'center'}}>
                                    {this.props.info.products[product]['price']}
                                </td>
                            </tr>
                        })}
                        <tr>
                            <td>
                                <TextField id={"otherNames"} label='List of other items with quantities' variant="outlined"
                                           value={this.state.otherNames} name={'otherNames'} onChange={this.update} fullWidth/>
                            </td>
                            <td style={{textAlign: 'center'}}>
                                N/A
                            </td>
                            <td>
                                <TextField id={"otherAmount"} label='Amount' variant="outlined" type='number'
                                           value={this.state.otherAmount} name={'otherAmount'} onChange={this.update} fullWidth/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <p style={{textAlign: 'center'}}>
                        <strong>
                            Total: {total}
                        </strong>
                    </p>
                    <p style={{textAlign: 'center'}}>
                        <Button variant="contained" onClick={() => this.props.callback(this.state, total)}>Buy Now</Button>
                    </p>
                </Paper>
            </Grid>
        );
    }
}